export default __webpack_public_path__ + "static/media/i218vp.fa3b3de2.webp";